import styles from './styles.module.css'
import Text from '../../../../Text'
import React from 'react'
import SecurePaymentBadgeIcon from '../../../../icons/checkout/SecurePaymentBadgeIcon'
import StripeLogo from '../../../../icons/checkout/StripeLogo'

function SecurePaymentBadge() {
  return (
    <div className={styles.additionalPaymentInfoWrapper}>
      <SecurePaymentBadgeIcon/>
      <div className={styles.textWrapper}>
        <Text type="heading-9">Safe & secure checkout</Text>
        <div className={styles.stripeEncryptionAndLogo}>
          <Text type="small">256-bit encrypted payment by</Text>
          <StripeLogo/>
        </div>
      </div>
    </div>
  )
}

export default SecurePaymentBadge
